import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';
import API from '../../axios/api';
import SpinnerOverlay from '../../UI/SpinnerOverlay/SpinnerOverlay';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const headerHeight = 64;
const paddingHeight = 50;

const Quicksight = (props) => {
	const dispatch = useDispatch();

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    document.body.style.overflow = 'hidden';

    window.addEventListener('resize', handleResize);
    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('resize', handleResize)
    }
  }, []);

	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
	}, [])

  useEffect(() => {
    setLoading(true);
    API.get('/quicksight/signurl')
      .then(res => {
        const containerDiv = document.getElementById("dashboardContainer");
        const url = res.data.EmbedUrl
        setLoading(false)
        const options = {
            url: url,
            container: containerDiv,
            scrolling: "no",
            height: `${windowDimensions.height - headerHeight + paddingHeight}`,
            width: "100%",
            locale: "en-US",
            footerPaddingEnabled: true,
            printEnabled: true
        };
        const dashboard = embedDashboard(options);
      })
      .catch(err => {
        console.log('err', err);
        setLoading(false)
      });
  }, [])

  return (
    <div style={{width: `calc('100%' + 48)`, height: `${windowDimensions.height - headerHeight + paddingHeight}`, scrolling: 'no', position: 'relative', margin: -24}}>
      {loading && <div style={{width: '100%', position: "relative", marginTop: 100}}><SpinnerOverlay/></div>}
      <div id="dashboardContainer" style={{width: '100%', height: `${windowDimensions.height - headerHeight + paddingHeight}`, scrolling: 'no'}}></div>
    </div>
  );
}

export default Quicksight;
